import deepMerge from 'deepmerge'
import { StorageProvider } from './storage'

function client(url: string, { body, headers = {}, method, ...others }: RequestInit = {}) {
  const token = StorageProvider.get('token')
  const email = StorageProvider.get('email')
  const customHeaders: any = {}

  if (token) {
    if (body && typeof body === 'object') {
      try {
        Object.assign(body, { uemail: email })
      } catch (ex) {}
    }
  }
  if (body && typeof body === 'object' && !(body instanceof FormData)) {
    body = JSON.stringify(body)
    customHeaders['Content-Type'] = 'application/json'
  }

  if (token) {
    customHeaders['Authorization'] = `JWT ${token}`
  }

  return window
    .fetch(url, {
      method,
      body,
      headers: deepMerge(customHeaders, headers as Headers),
      ...others,
    })
    .then(async (response) => {
      const notInLoginPage = !window.location.href.includes('/login')
      const isPdf = response.headers.get('Content-Type') === 'application/pdf'

      if (response?.status === 401 && notInLoginPage) {
        StorageProvider.remove('token')
        window.location.href = '/login'
        return
      }
      // TODO: Enable once staging doesn't return 403 error in /organization
      // else if (response?.status === 403) {
      //   window.location.href = '/'
      //   return
      // }

      let data

      try {
        data = await (isPdf ? response.blob() : response.json())
      } catch (error) {
        // Swallow
      }

      return response.ok ? data : Promise.reject(data)
    })
}

const buildClient = (baseUrl: string) => ({
  get: (endpoint: string, options?: RequestInit) => {
    return client(`${baseUrl}${endpoint}`, { method: 'GET', ...options })
  },
  post: (endpoint: string, body?: any, options?: RequestInit) => {
    return client(`${baseUrl}${endpoint}`, { method: 'POST', body, ...options })
  },
  patch: (endpoint: string, body?: any, options?: RequestInit) => {
    return client(`${baseUrl}${endpoint}`, { method: 'PATCH', body, ...options })
  },
  delete: (endpoint: string, options?: RequestInit) => {
    return client(`${baseUrl}${endpoint}`, { method: 'DELETE', ...options })
  },
})

export const ApiProvider = buildClient(process.env.REACT_APP_API_URL!)
export const MapServerProvider = buildClient(process.env.REACT_APP_MAP_SERVER_URL!)
export const JunctionProvider = buildClient(process.env.REACT_APP_JUNCTION_URL!)
